import { Theme } from '@mui/material/styles';

export const action = (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(4),
}) as const;

export const snackbar = (theme: Theme) => ({
    left: '0 !important',
    right: '0 !important',
    top: '50% !important',
    bottom: 'auto !important',
    transform: 'translateY(-50%) !important',
    marginX: theme.spacing(2),

    '& .MuiAlert-root': {
        alignItems: 'center',
    },

    '& .MuiAlert-action': {
        paddingTop: 0,
    },
}) as const;
